import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

const STORAGE_KEY = 'akara.cookieConsent'
const GA_ID = 'G-0121F5Y0R9'
const METRICOOL_HASH = '5ea9bbccccc177d7786b40923cae2395'

const loadAnalytics = () => {
  if (typeof window === 'undefined' || window.gtag) return
  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`
  document.head.appendChild(script)

  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag() {
    window.dataLayer.push(arguments)
  }
  window.gtag('js', new Date())
  window.gtag('config', GA_ID, { anonymize_ip: true })

  // Metricool traffic tracker — same consent gate as GA above.
  const metricoolScript = document.createElement('script')
  metricoolScript.type = 'text/javascript'
  metricoolScript.src = 'https://tracker.metricool.com/resources/be.js'
  const fireMetricool = () => window.beTracker?.t({ hash: METRICOOL_HASH })
  metricoolScript.onreadystatechange = fireMetricool
  metricoolScript.onload = fireMetricool
  document.head.appendChild(metricoolScript)
}

function CookieBanner() {
  const [visible, setVisible] = useState(
    () => typeof window !== 'undefined' && window.localStorage.getItem(STORAGE_KEY) == null,
  )

  useEffect(() => {
    // Only an external side-effect here (load analytics if previously accepted);
    // initial visibility is derived in the useState initializer above.
    if (window.localStorage.getItem(STORAGE_KEY) === 'accepted') {
      loadAnalytics()
    }
  }, [])

  const setConsent = (value) => {
    window.localStorage.setItem(STORAGE_KEY, value)
    if (value === 'accepted') {
      loadAnalytics()
    }
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className="cookie-banner" role="dialog" aria-live="polite" aria-label="Cookie consent">
      <div className="cookie-banner__content">
        <p>
          We use essential cookies to keep the platform secure and optional analytics to
          improve performance. You can manage your consent at any time.
        </p>
        <div className="cookie-banner__actions">
          <button className="secondary-button" type="button" onClick={() => setConsent('declined')}>
            Decline
          </button>
          <button className="primary-button" type="button" onClick={() => setConsent('accepted')}>
            Accept
          </button>
          <Link className="inline-link" to="/privacy-policy">
            Privacy policy
          </Link>
        </div>
      </div>
    </div>
  )
}

export default CookieBanner
